import {Component, OnInit} from '@angular/core';
import {LoadingService} from './loading.service';
import {NzMessageService} from 'ng-zorro-antd';
import {isUndefined} from 'util';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
    showLoading = false;
    messageId: any;

    constructor(private _loading: LoadingService, private _message: NzMessageService) {
    }

    ngOnInit() {
        this._loading.status.subscribe((status: boolean) => {
            this.showLoading = status;
            if (!isUndefined(this.messageId)) {
                this._message.remove(this.messageId);
            }
        });
    }


    onClick() {
        if (!isUndefined(this.messageId)) {
            this._message.remove(this.messageId);
        }

        if (this.showLoading) {
            this.messageId = this._message.loading('正在努力加载...', {nzDuration: 0}).messageId;
            console.log(this.messageId);
        }
    }
}
